<template>
    <div>
        <div class="top_banner">
            <div class="top_banner_text">
                <p>联系我们</p>
            </div>
        </div>
        <div class="about_us_bg about_us_bg_diff">
            <div>
                <div class="w_1200 w_1200_boot diff_padding">
                    <div class="contact_block2">
                        <h5 class="contact_title">联系我们</h5>
                        <div class="contact_block2_btm clearfix">
                            <table class="contact_detail_msg">
                                <colgroup>
                                    <col width="35%">
                                    <col width="35%">
                                    <col width="30">
                                </colgroup>
                                <tbody>
                                <tr>
                                    <td><h1 class="companyName b">{{fromData.companyName}}</h1></td>
                                    <td><span class="b">邮编：</span><span class="postCode">{{fromData.postCode}}</span></td>
                                    <td><span class="b">简历投递：</span><span class="resumeDeliver">{{fromData.resumeDeliver}}</span></td>
                                </tr>
                                <tr>
                                    <td><span class="b">地址：</span><span class="address">{{fromData.address}}</span></td>
                                    <td><span class="b">Email：</span><span class="email">{{fromData.email}}</span></td>
                                    <td><span class="b">服务热线：</span><span class="serviceHotline">{{fromData.serviceHotline}}</span></td>
                                </tr>
                                </tbody>
                            </table>
                            <table class="mobile_table_show">
                                <colgroup>
                                    <col width="100%">
                                </colgroup>
                                <tbody>
                                <tr>
                                    <td><span class="b companyName">{{fromData.companyName}}</span></td>
                                </tr>
                                <tr>
                                    <td><span class="b">邮编：</span><span class="postCode">{{fromData.postCode}}</span></td>
                                </tr>
                                <tr>
                                    <td><span class="b">简历投递：</span><span class="resumeDeliver">{{fromData.resumeDeliver}}</span></td>
                                </tr>
                                <tr>
                                    <td><span class="b">地址：</span><span class="address">{{fromData.address}}</span></td>
                                </tr>
                                <tr>
                                    <td><span class="b">Email：</span><span class="email">{{fromData.email}}</span></td>
                                </tr>
                                <tr>
                                    <td><span class="b">服务热线：</span><span class="serviceHotline">{{fromData.serviceHotline}}</span></td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="contact_detail_map">
                                <div id="allmap"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="diff_bg">
                <div class="w_1200 w_1200_boot non_margin non_padding">
                    <div class="about_us non_about_us layui-form" lay-filter="submit">
                        <div class="about_tap clearfix">
                            <a href="aboutUs.html">公司简介</a>
                            <!--              <a href="aboutUsEmploy.html">招聘信息</a>-->
                            <a href="aboutUsAddress.html" class="on">联系我们</a>
                        </div>
                        <div class="contact_us contact_us_mobile clearfix">
                            <div>
                                <h5 class="contact_title">在线反馈</h5>
                                <div class="contact_input clearfix">
                                    <input type="text" required placeholder="姓名" v-model="dateDas.name" class="name" lay-verify="required"
                                           maxlength="32">
                                    <input type="text" required placeholder="单位" v-model="dateDas.userName" class="unit" lay-verify="required"
                                           maxlength="32">
                                    <div class="inner">
                                        <input type="text" required placeholder="电子邮件" v-model="dateDas.email" class="email"
                                               lay-verify="required|email" maxlength="32">
                                        <input type="text" required placeholder="电话" v-model="dateDas.phone" class="phone"
                                               lay-verify="required|phone" maxlength="32">
                                    </div>
                                    <textarea required placeholder="输入内容" v-model="dateDas.context" class="content" lay-verify="required"
                                              maxlength="256"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="contact_btn">
                            <button type="button" @click="fun_add()">提交</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: "aboutUsAddress",
        data() {
            return {
                from: null,
                to: null,
                fromData:{},
                dateDas:{}
            }
        },
        mounted() {
            var map = new BMap.Map("allmap");    // 创建Map实例
            var point = new BMap.Point(117.159825, 36.665143);
            map.centerAndZoom(point, 18);  // 初始化地图,设置中心点坐标和地图级别
            map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
            var myIcon = new BMap.Icon(require("@/assets/img/icon_location_map.png"), new BMap.Size(230, 230));
            var marker = new BMap.Marker(point, {icon: myIcon});
            map.addOverlay(marker);
            this.get_data()
        },
        methods: {
            get_data(){
                this.$SIF.httpGet({
                    url: this.$SIF._serve.menhu + "/company/query",
                    succFun: res => {
                        this.fromData = res.data[0]
                    }, failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
                // /company/query
            },
            fun_add(){
                if(!this.dateDas.name || !this.dateDas.email|| !this.dateDas.phone|| !this.dateDas.context){
                    this.$message({
                        message: '请输入反馈信息及联系方式。',
                        type: 'warning'
                    });
                    return
                }
                this.$SIF.httpPost({
                    url: this.$SIF._serve.menhu + "/feedback/save",
                    data:this.dateDas,
                    succFun: res => {
                        this.dateDas = {}
                        this.$message({
                            message: '反馈提交成功',
                            type: 'success'
                        });
                    },
                    failFun: res => {
                        this.$message({
                            message: res.msg,
                            type: 'warning'
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .top_banner {
        background-image: url(~@/assets/img/banner/aboutUsAddress_banner.png);
        background-size: 100% 100%;

    }
</style>